import { __awaiter, __generator } from "tslib";
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { DimeState } from './../state';
import { logDimeEvent } from './../telemetry';
export var initializeDime = function (puid, upn, pwaEnabled, preferredCulture, sessionId) { return __awaiter(void 0, void 0, void 0, function () {
    var dimeConfig;
    return __generator(this, function (_a) {
        if (DimeState.dime) {
            return [2 /*return*/, 1 /* DimeTaskStatus.Completed */];
        }
        if (DimeState.dimeDisabled) {
            return [2 /*return*/, 2 /* DimeTaskStatus.Disabled */];
        }
        if (typeof Dime === 'undefined') {
            DimeState.dimeDisabled = true;
            logDimeEvent({
                eventName: KnownInstrumentationEvents.DimeInitialize,
                dimeExperience: '',
                result: 'Failed',
                metaData: 'Dime Undefined',
            });
            throw new Error('Unable to initialize. Dime is undefined.');
        }
        performance.mark('DimeInitialize_Start');
        dimeConfig = {
            partnerId: pwaEnabled ? 'officepwa' : 'officedotcom',
            language: preferredCulture,
            sessionId: sessionId,
            authHint: pwaEnabled ? puid : upn,
            userInfo: {
                puid: puid,
            },
        };
        try {
            DimeState.dime = new Dime(dimeConfig);
            performance.mark('DimeInitialize_Complete');
            logDimeEvent({
                eventName: KnownInstrumentationEvents.DimeInitialize,
                dimeExperience: '',
                result: 'Succeeded',
            });
            return [2 /*return*/, 1 /* DimeTaskStatus.Completed */];
        }
        catch (e) {
            DimeState.dimeDisabled = true;
            logDimeEvent({
                eventName: KnownInstrumentationEvents.DimeInitialize,
                dimeExperience: '',
                result: 'Failed',
                metaData: e && typeof e === 'object' ? e : undefined,
            });
            throw new Error('Error encountered while initializing Dime.');
        }
        return [2 /*return*/];
    });
}); };
//# sourceMappingURL=initializeDime.js.map